import styled from 'styled-components';

export const TopCampaigns = styled.div`
  padding-left: 0 !important;
  padding-right: 0 !important;
  background-color: #333;
  color: #fff;
`;
